export const SearchIcon = ({ color }) => {
    return (
        // prettier-ignore
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M20 18.586L18.586 20L14.343 15.758L15.757 14.343L20 18.586ZM8 14C4.692 14 2 11.309 2 8C2 4.692 4.692 2 8 2C11.308 2 14 4.692 14 8C14 11.309 11.308 14 8 14ZM8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0Z" fill={color ? color : "white"}/>
        </svg>
    )
}
